<template>
  <div class="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
    <div
      class="group border rounded-2xl shadow-sm border-ewhite-200 bg-white hover:shadow-xl hover:shadow-eorange-500/10 transition-all duration-300 hover:border-eorange-300 hover:-translate-y-1 overflow-hidden"
      v-for="customer in customers_list"
      :key="customer.id"
    >
      <div class="p-6">
        <div class="flex items-start gap-4 mb-4">
          <div
            class="w-14 h-14 rounded-full flex items-center justify-center bg-gradient-to-br from-ewhite-50 to-eblack-300 text-white font-bold text-lg shadow-md flex-shrink-0"
          >
            {{ getInitials(customer.name, customer.last_name) }}
          </div>
          <div class="flex-1 min-w-0">
            <h3 class="font-bold text-lg text-gray-900 mb-1 truncate">
              {{ `${customer.name} ${customer.last_name}` }}
            </h3>
            <div class="flex items-center gap-2 flex-wrap">
              <span
                class="bg-gray-100 text-gray-700 hover:bg-gray-100 text-xs px-4 py-1 rounded-full transition-colors"
              >
                {{ customer.dni != "" ? customer.dni : "DNI no agregado" }}
              </span>
            </div>
          </div>
        </div>

        <div class="space-y-3 mb-5">
          <div class="flex items-center gap-3 text-sm text-gray-700 group">
            <div
              class="p-2 bg-egreen-200 rounded-lg group-hover:bg-egreen-400 transition-colors"
            >
              <IconBrandWhatsapp class="w-4 h-4 text-egreen-600" />
            </div>
            <span class="font-medium">{{
              formatPhone(customer.whatsapp_phone)
            }}</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-gray-700 group">
            <div
              class="p-2 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors"
            >
              <IconMail class="w-4 h-4 text-blue-600" />
            </div>
            <span class="truncate font-medium">{{ customer.email }}</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-gray-700 group">
            <div
              class="p-2 bg-orange-50 rounded-lg group-hover:bg-orange-100 transition-colors"
            >
              <IconMapPin class="w-4 h-4 text-orange-600" />
            </div>
            <span class="font-medium">{{
              getCountryName(customer.country)
            }}</span>
          </div>
        </div>

        <div
          class="px-6 py-4 bg-ewhite-50/50 border-t border-ewhite-100 mt-auto"
        >
          <div class="flex gap-2">
            <button
              class="inline-flex flex-1 gap-1 p-2.5 text-sm text-white bg-eblue-500 rounded-xl items-center justify-center"
              type="button"
              @click="handleShow(customer)"
            >
              <IconEdit class="w-7 h-7" stroke="{2}" />
              <span>{{ $t("customer.auto.editar") }}</span>
            </button>
            <button
              class="inline-flex flex-1 items-center justify-center gap-1 p-2.5 text-sm text-white bg-eblack-600 rounded-xl"
              type="button"
              @click="handleShow(customer, true)"
            >
              <IconEye class="w-7 h-7" stroke="{2}" />
              <span>{{ $t("customer.auto.ver_info") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/utils/country-name";
import { formatPhoneNumberForDisplay } from "@/shared/utils/phone-number";
import {
  IconBrandWhatsapp,
  IconEdit,
  IconEye,
  IconMail,
  IconMapPin,
} from "@tabler/icons-vue";

export default {
  props: ["customers", "showModal", "search"],
  data() {
    return {
      customers_list: [],
    };
  },
  watch: {
    customers: {
      handler(value) {
        this.customers_list = [...value];
      },
    },
    search: {
      handler(value) {
        this.applySearch(value);
      },
      immediate: true,
    },
  },
  components: {
    IconMail,
    IconEye,
    IconEdit,
    IconBrandWhatsapp,
    IconMapPin,
  },
  methods: {
    getCountryName,
    formatPhone(value) {
      return formatPhoneNumberForDisplay(value) || "Sin teléfono";
    },
    applySearch(value) {
      if (value != "") {
        this.customers_list = this.customers.filter((customer) =>
          customer.name.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        this.customers_list = this.customers;
      }
    },
    handleShow(customer, viewClicked = false) {
      this.showModal(customer, viewClicked);
    },
    getInitials(firstName, lastName) {
      const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
      const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
      return firstInitial + lastInitial;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
